export default "__VITE_ASSET__CIeAhwji__"